var _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrand1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "572.41 749.864 2675.7 588.546",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsVectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 588.546,
    width: 2675.7,
    x: 572.41,
    y: 749.864
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Layer",
    vectornatorLayerName: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    vectornatorLayerName: "Gruppieren 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.41 749.864L1635.87 749.864L1635.87 1338.41L572.41 1338.41L572.41 749.864Z",
    fill: "#ff317c",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none",
    vectornatorLayerName: "Rechteck 1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    vectornatorLayerName: "Gruppieren 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M769.54 1178.48C845.92 1178.48 887.34 1129.46 894.56 1073.22L832.24 1073.22C829.2 1103.62 809.82 1132.5 769.54 1132.5C728.12 1132.5 700 1100.96 700 1038.26C700 975.556 726.22 944.776 769.54 944.776C810.58 944.776 829.58 972.896 832.24 1005.96L894.56 1005.96C889.24 947.056 847.06 898.796 769.54 898.796C686.32 898.796 636.54 952.756 636.54 1038.26C636.54 1123.76 690.12 1178.48 769.54 1178.48Z",
    fill: "#f8f8f8",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.72 1178.48C1080.38 1178.48 1127.88 1139.34 1127.88 1067.14C1127.88 994.936 1080.38 955.796 1020.72 955.796C961.06 955.796 913.56 994.936 913.56 1067.14C913.56 1139.34 961.06 1178.48 1020.72 1178.48ZM973.98 1067.14C973.98 1022.3 991.08 998.736 1020.72 998.736C1050.36 998.736 1067.46 1022.3 1067.46 1067.14C1067.46 1111.98 1050.36 1135.54 1020.72 1135.54C991.08 1135.54 973.98 1111.98 973.98 1067.14Z",
    fill: "#f8f8f8",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.56 1178.48C1314.46 1178.48 1348.66 1141.62 1354.36 1096.02L1296.98 1096.02C1294.7 1113.88 1282.92 1135.54 1255.56 1135.54C1225.54 1135.54 1208.82 1109.32 1208.82 1067.14C1208.82 1027.24 1222.88 998.736 1255.56 998.736C1284.06 998.736 1295.46 1018.88 1296.98 1042.44L1354.36 1042.44C1349.8 992.656 1316.36 955.796 1255.56 955.796C1188.68 955.796 1148.4 999.496 1148.4 1067.14C1148.4 1134.78 1191.72 1178.48 1255.56 1178.48Z",
    fill: "#f8f8f8",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.44 1171.64L1436.06 1171.64L1436.06 1115.4L1462.28 1086.14L1463.04 1086.14L1513.96 1171.64L1583.88 1171.64L1501.42 1044.34L1575.52 962.636L1509.4 962.636L1436.82 1047.38L1436.06 1047.38L1436.06 874.856L1379.44 874.856L1379.44 1171.64Z",
    fill: "#f8f8f8",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    vectornatorLayerName: "Gruppieren 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1702.27 1259.14L1761.55 1259.14L1761.55 1159.58L1793.47 1159.58C1829.95 1159.58 1842.11 1170.22 1851.61 1212.78L1861.87 1259.14L1923.81 1259.14L1908.61 1204.04C1898.35 1167.94 1884.67 1145.14 1853.51 1133.74L1853.51 1132.98C1894.17 1125.38 1915.83 1099.92 1915.83 1065.34C1915.83 1021.26 1881.25 993.136 1820.45 993.136L1702.27 993.136L1702.27 1259.14ZM1761.55 1113.6L1761.55 1039.12L1807.15 1039.12C1839.83 1039.12 1854.65 1052.8 1854.65 1075.6C1854.65 1099.54 1837.55 1113.6 1800.69 1113.6L1761.55 1113.6Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040.85 1265.98C2100.51 1265.98 2148.01 1226.84 2148.01 1154.64C2148.01 1082.44 2100.51 1043.3 2040.85 1043.3C1981.19 1043.3 1933.69 1082.44 1933.69 1154.64C1933.69 1226.84 1981.19 1265.98 2040.85 1265.98ZM1994.11 1154.64C1994.11 1109.8 2011.21 1086.24 2040.85 1086.24C2070.49 1086.24 2087.59 1109.8 2087.59 1154.64C2087.59 1199.48 2070.49 1223.04 2040.85 1223.04C2011.21 1223.04 1994.11 1199.48 1994.11 1154.64Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2247.19 1265.98C2273.41 1265.98 2294.69 1254.96 2307.23 1231.4L2307.99 1231.4L2307.99 1259.14L2363.85 1259.14L2363.85 1050.14L2307.23 1050.14L2307.23 1173.64C2307.23 1209.74 2287.85 1222.66 2267.33 1222.66C2246.05 1222.66 2232.75 1208.98 2232.75 1177.82L2232.75 1050.14L2176.13 1050.14L2176.13 1184.66C2176.13 1238.62 2205.77 1265.98 2247.19 1265.98Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2404.51 1259.14L2461.13 1259.14L2461.13 962.356L2404.51 962.356L2404.51 1259.14Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2594.13 1265.98C2646.95 1265.98 2683.05 1237.1 2692.17 1194.92L2634.41 1194.92C2629.09 1212.02 2615.41 1223.04 2595.27 1223.04C2568.67 1223.04 2551.19 1202.9 2550.05 1169.84L2695.59 1169.84L2695.59 1148.18C2695.59 1077.88 2652.27 1043.3 2593.75 1043.3C2533.33 1043.3 2490.01 1083.2 2490.01 1154.64C2490.01 1225.7 2532.19 1265.98 2594.13 1265.98ZM2550.43 1131.46C2551.95 1106 2566.39 1086.24 2595.65 1086.24C2624.15 1086.24 2638.97 1105.24 2638.97 1131.46L2550.43 1131.46Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800.47 1259.14L2861.27 1259.14L2861.27 1214.68L2824.03 1214.68C2808.07 1214.68 2798.95 1207.84 2798.95 1189.98L2798.95 1094.6L2860.51 1094.6L2860.51 1050.14L2798.95 1050.14L2798.95 993.136L2742.71 993.136L2742.71 1050.14L2703.19 1050.14L2703.19 1094.6L2742.71 1094.6L2742.71 1201.76C2742.71 1240.14 2762.09 1259.14 2800.47 1259.14Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2970.33 1259.14L3031.13 1259.14L3031.13 1214.68L2993.89 1214.68C2977.93 1214.68 2968.81 1207.84 2968.81 1189.98L2968.81 1094.6L3030.37 1094.6L3030.37 1050.14L2968.81 1050.14L2968.81 993.136L2912.57 993.136L2912.57 1050.14L2873.05 1050.14L2873.05 1094.6L2912.57 1094.6L2912.57 1201.76C2912.57 1240.14 2931.95 1259.14 2970.33 1259.14Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3146.65 1265.98C3199.47 1265.98 3235.57 1237.1 3244.69 1194.92L3186.93 1194.92C3181.61 1212.02 3167.93 1223.04 3147.79 1223.04C3121.19 1223.04 3103.71 1202.9 3102.57 1169.84L3248.11 1169.84L3248.11 1148.18C3248.11 1077.88 3204.79 1043.3 3146.27 1043.3C3085.85 1043.3 3042.53 1083.2 3042.53 1154.64C3042.53 1225.7 3084.71 1265.98 3146.65 1265.98ZM3102.95 1131.46C3104.47 1106 3118.91 1086.24 3148.17 1086.24C3176.67 1086.24 3191.49 1105.24 3191.49 1131.46L3102.95 1131.46Z",
    fill: "#ededed",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand1);
export default __webpack_public_path__ + "static/media/brand_1.936cb9b64a363329d14b22225e49ee72.svg";
export { ForwardRef as ReactComponent };